import { useState } from 'react';
import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import FormikInput from 'components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../walkthroughIds';

const OrganizationIdField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.organizationId && touched.organizationId}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    8x8 Organization ID{' '}
                    <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Field
                    as={FormikInput}
                    id="organizationId"
                    name="organizationId"
                    placeholder="e.g. 8x8-ORG-100001"
                    maxLength={50}
                    data-walkthroughid={
                        walkthroughIds.createMode.ufOrganizationIdInput
                    }
                    error={errors.organizationId}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter the 8x8 Organization ID for this service provider."
                        ariaLabel="service-provider-org-id-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default OrganizationIdField;
